import {defineComponent} from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlPublic',
    props: {},
    setup(props) {
    }
})
